import React from "react";
import GradingIcon from "@mui/icons-material/Grading";
import { Modal, Box } from "@mui/material";

// Simulated data for the bio
const bioData = {
  class: "Senior",
  hometown: "Los Angeles, CA",
  position: "Forward",
  birthday: "March 15, 2003",
  height: "6'7\"",
  weight: "210 lbs",
  twitter: "@zylan_bernard",
  instagram: "@zylan.bernard",
  snapchat: "@zylanbernard03",
  highSchool: "Sunset High School",
  highSchoolCoach: "Coach Williams",
  aauTeam: "LA Elite",
  aauCoach: "Coach Jackson",
  basketballHonors: [
    "All-State First Team (2023)",
    "Regional MVP (2022)",
    "Team Captain (2022-2023)",
    "McDonald's All-American Nominee",
    "AAU Tournament MVP (2021)",
  ],
};

const BioTab = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="bio-tab">
      <div className="bio-box">
        <h3>Personal Information</h3>
        <p>
          <strong>Class:</strong> {bioData.class}
        </p>
        <p>
          <strong>Hometown:</strong> {bioData.hometown}
        </p>
        <p>
          <strong>Position:</strong> {bioData.position}
        </p>
        <p>
          <strong>Birthday:</strong> {bioData.birthday}
        </p>
        <p>
          <strong>Height:</strong> {bioData.height}
        </p>
        <p>
          <strong>Weight:</strong> {bioData.weight}
        </p>
      </div>

      <div className="bio-box">
        <h3>Social Media</h3>
        <p>
          <strong>Twitter:</strong> {bioData.twitter}
        </p>
        <p>
          <strong>Instagram:</strong> {bioData.instagram}
        </p>
        <p>
          <strong>Snapchat:</strong> {bioData.snapchat}
        </p>
      </div>

      <div className="bio-box">
        <h3>School and Team Info</h3>

        <p>
          <strong>High School:</strong> {bioData.highSchool}
        </p>
        <p>
          <strong>High School Coach:</strong> {bioData.highSchoolCoach}
        </p>
        <p>
          <strong>AAU Team:</strong> {bioData.aauTeam}
        </p>
        <p>
          <strong>AAU Coach:</strong> {bioData.aauCoach}
        </p>
        <div
          className="transcript-button"
          onClick={handleOpen}
          style={{ cursor: "pointer" }}
        >
          <GradingIcon sx={{ fontSize: 30 }} />
          <span>View Academic Transcript</span>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        aria-labelledby="transcript-modal"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: {
              xs: "95vw",
              sm: "80vh",
            },
            height: {
              xs: "80vh",
              sm: "103vh",
            },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 1,
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          <img
            src="https://www.greatschoolspartnership.org/wp-content/uploads/2022/02/GSP_Exemplar_Transcript_pg1_watermark.png"
            alt="Academic Transcript"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              maxWidth: "100%",
              maxHeight: "100%",
            }}
          />
        </Box>
      </Modal>

      <div className="bio-box">
        <h3>Basketball Honors</h3>
        <ul>
          {bioData.basketballHonors.map((honor, index) => (
            <li key={index}>{honor}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BioTab;
